/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { takeLatest, ForkEffect } from 'redux-saga/effects';
import ActionConstants from '../constants';
import workerSaga from './workerSaga';

export default function* feeConfigurationWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  // Entity CRUD
  yield takeLatest(ActionConstants.GET_FEE_CONFIG_CONVENIENCE_FEES, workerSaga);
  yield takeLatest(ActionConstants.GET_FEE_CONFIG_CONVENIENCE_FEE_DETAIL, workerSaga);
  yield takeLatest(ActionConstants.GET_FEE_CONFIG_FEATURE_FEES, workerSaga);
  yield takeLatest(ActionConstants.GET_FEE_CONFIG_MERCHANT_MAPPINGS, workerSaga);
  yield takeLatest(ActionConstants.GET_FEE_CONFIG_MERCHANT_FEE_MAPPINGS, workerSaga);
  yield takeLatest(ActionConstants.GET_FEE_CONFIG_PAYMENT_MODES, workerSaga);
  yield takeLatest(ActionConstants.GET_FEE_CONFIG_NETWORK_TYPES, workerSaga);

  // Change requests (approval workflow)
  yield takeLatest(ActionConstants.SUBMIT_FEE_CONFIG_CHANGE_REQUEST, workerSaga);
  yield takeLatest(ActionConstants.GET_FEE_CONFIG_CHANGE_REQUESTS, workerSaga);
  yield takeLatest(ActionConstants.GET_FEE_CONFIG_CHANGE_REQUEST_DETAIL, workerSaga);
  yield takeLatest(ActionConstants.APPROVE_FEE_CONFIG_CHANGE_REQUEST, workerSaga);
  yield takeLatest(ActionConstants.REJECT_FEE_CONFIG_CHANGE_REQUEST, workerSaga);
  yield takeLatest(ActionConstants.GET_FEE_CONFIG_EXECUTION_STATUS, workerSaga);
}
